import { UserPayload } from '@app/api/models/user';

import { UserFormInstance } from '../types';

export const mapInstance = (
  formInstance: Partial<UserFormInstance>
): UserPayload => {
  
  return {
    ...(formInstance.user_id ? { id: formInstance.user_id } : {}),
    role_id: Number(formInstance.role?.id || 0),
    group_id: Number(formInstance.group?.id || 0),
    first_name: formInstance.first_name,
    last_name: formInstance.last_name,
    password: formInstance.password,
    email: formInstance.email,
    phone: formInstance.phone || undefined,
    location: formInstance.location,
    comment: formInstance.comment,
    is_active: formInstance.active,
    distributor_id: formInstance.distributor ? Number(formInstance.distributor?.id) : undefined,
    position_id: Number(formInstance.position?.id || 0),
    boss_id: formInstance.boss?.id.toString() || null,
  };
};
